import axios from 'axios'

import { basicRequestInterceptor } from '../../../interceptors/http-interceptor/basic'
import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { errorResponseInterceptor } from '../../../interceptors/http-interceptor/errorResponse'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'

export const configureBasicAPI = (url: string) => {
  const instance = axios.create({ baseURL: url })

  instance.interceptors.request.use(
    basicRequestInterceptor,
    errorRequestInterceptor
  )
  instance.interceptors.response.use(
    responseInterceptor,
    errorResponseInterceptor
  )

  return instance
}
